import React from 'react';
import PropTypes from 'prop-types';
import DetailsViewManagerComponent from '@Components/Results/reactions/reaction-details/additional-data/details-view-manager.component';
import ReactReactionAdditionalInfoHelper from '@Components/Results/services/react-reaction-additional-info-helper.service';
import ReactionProtectingGroups from '@Components/Results/reactions/reaction-details/additional-data/reaction-protecting-groups.component';
import ReactionMetabolizationGroups from '@Components/Results/reactions/reaction-details/additional-data/ReactionMetabolizationGroups';
import ReactionAdditionalData from '@Components/Results/reactions/reaction-details/additional-data/ReactionAdditionalData';

import './ReactionAdditionalData.scss';

export default class ReactionAdditionalInfoComponent extends React.Component {
  constructor(props) {
    super(props);

    const { detail } = this.props;

    this.state = {
      isReactantsProductsVisible: ReactReactionAdditionalInfoHelper.isReactantsProductsVisible(detail),
      isReagentsVisible: ReactReactionAdditionalInfoHelper.isReagentsVisible(detail),
      isReactantsProductsOnStageVisible: ReactReactionAdditionalInfoHelper.isReactantsProductsOnStageVisible(detail),
      isProtectingGroupsVisible: ReactReactionAdditionalInfoHelper.hasCollection(detail.protectingGroups),
      isMetabolizationGroupsVisible: ReactReactionAdditionalInfoHelper.hasCollection(detail.metabolizationGroups),

      isTableVisible: {
        reactantsProducts: false,
        reagents: false,
        reactantsProductsOnStage: false,
        protectingGroups: false,
        metabolizationGroups: false,
      },
    };

    this.reactantsData = ReactReactionAdditionalInfoHelper.getDetailData('reactants', detail);
    this.productsData = ReactReactionAdditionalInfoHelper.getDetailData('products', detail);
    this.reactantsOnStagesLevelData = ReactReactionAdditionalInfoHelper.getDetailDataOnStagesLevel('reactants', detail);
    this.productsOnStagesLevelData = ReactReactionAdditionalInfoHelper.getDetailDataOnStagesLevel('products', detail);
    this.reagentsSolventsData = ReactReactionAdditionalInfoHelper.getReagentsSolventsCatalystsOnStagesLevel(detail);

    this.reactionMetabolizationGroupsContainerRef = React.createRef();
  }

  setVisibility(indicator, value) {
    const { isTableVisible } = this.state;
    isTableVisible[indicator] = value;

    this.setState({ isTableVisible });
  }

  render() {
    const { index, databaseId, detail, reactionId } = this.props;
    const {
      isReactantsProductsVisible,
      isTableVisible,
      isReactantsProductsOnStageVisible,
      isReagentsVisible,
      isProtectingGroupsVisible,
      isMetabolizationGroupsVisible,
    } = this.state;

    return (
      <div className="additional-info-container">
        {/* Additional Information on Reactants/Products */}
        {isReactantsProductsVisible && (
          <>
            <div className="additional-info-header">
              <DetailsViewManagerComponent
                title="Additional Information on Reactants/Products"
                // eslint-disable-next-line react/jsx-no-bind
                setVisibility={this.setVisibility?.bind?.(this, 'reactantsProducts')}
                ariaControls={`info-reactants-products-${index}`}
              />
            </div>

            <div
              className={`additional-info-details info-reactants-products rx-accordion
                          ${isTableVisible.reactantsProducts ? '' : 'u-els-display-none'}`}
              id={`info-reactants-products-${index}`}>
              {this.reactantsData && this.reactantsData.length && (
                <ReactionAdditionalData
                  data={this.reactantsData}
                  viewMode="reactants"
                  accordionTitle="Reactants"
                  uniqueId={`info-reactants-products-reactants-${index}`}
                  databaseId={databaseId}
                  detail={detail}
                  reactionId={reactionId}
                />
              )}

              {this.productsData && this.productsData.length && (
                <ReactionAdditionalData
                  data={this.productsData}
                  viewMode="products"
                  accordionTitle="Products"
                  uniqueId={`info-reactants-products-products-${index}`}
                  databaseId={databaseId}
                  detail={detail}
                  reactionId={reactionId}
                />
              )}
            </div>
          </>
        )}

        {/* Additional Information on Reactants/Products on Stages Level */}
        {isReactantsProductsOnStageVisible && (
          <>
            <div className="additional-info-header">
              <DetailsViewManagerComponent
                title="Additional Information on Reactants/Products on Stages Level"
                // eslint-disable-next-line react/jsx-no-bind
                setVisibility={this.setVisibility?.bind?.(this, 'reagents')}
                ariaControls={`info-reactants-products-onstages-${index}`}
              />
            </div>
            <div
              className={`additional-info-details info-reactants-products-onstages rx-accordion
                          ${isTableVisible.reagents ? '' : 'u-els-display-none'}`}
              id={`info-reactants-products-onstages-${index}`}>
              {this.reactantsOnStagesLevelData && this.reactantsOnStagesLevelData.length && (
                <ReactionAdditionalData
                  data={this.reactantsOnStagesLevelData}
                  viewMode="reactants"
                  accordionTitle="Reactants"
                  stages="true"
                  uniqueId={`info-reactants-products-onstages-reactants-${index}`}
                  databaseId={databaseId}
                  detail={detail}
                  reactionId={reactionId}
                />
              )}

              {this.productsOnStagesLevelData && this.productsOnStagesLevelData.length && (
                <ReactionAdditionalData
                  data={this.productsOnStagesLevelData}
                  viewMode="products"
                  accordionTitle="Products"
                  stages="true"
                  uniqueId={`info-reactants-products-onstages-products-${index}`}
                  databaseId={databaseId}
                  detail={detail}
                  reactionId={reactionId}
                />
              )}
            </div>
          </>
        )}

        {/* Additional Information on Reagents/Solvents/Catalysts */}
        {isReagentsVisible && (
          <>
            <div className="additional-info-header">
              <DetailsViewManagerComponent
                title="Additional Information on Reagents/Solvents/Catalysts"
                // eslint-disable-next-line react/jsx-no-bind
                setVisibility={this.setVisibility?.bind?.(this, 'reactantsProductsOnStage')}
                ariaControls={`info-reagents-solvents-catalysts-${index}`}
              />
            </div>
            <div
              className={`additional-info-details info-reagents-solvents-catalysts rx-accordion
                          ${isTableVisible.reactantsProductsOnStage ? '' : 'u-els-display-none'}`}
              id={`info-reagents-solvents-catalysts-${index}`}>
              {this.reagentsSolventsData && this.reagentsSolventsData.length && (
                <ReactionAdditionalData
                  data={this.reagentsSolventsData}
                  viewMode="reactants"
                  accordionTitle="Reagents/Solvents/Catalysts"
                  stages="true"
                  roles="true"
                  uniqueId={`detailed-info-reagents-solvents-catalysts-${index}`}
                  databaseId={databaseId}
                  detail={detail}
                  reactionId={reactionId}
                />
              )}
            </div>
          </>
        )}

        {/* Information on Protecting Groups */}
        {isProtectingGroupsVisible && (
          <>
            <div className="additional-info-header">
              <DetailsViewManagerComponent
                title="Information on Protecting Groups"
                // eslint-disable-next-line react/jsx-no-bind
                setVisibility={this.setVisibility?.bind?.(this, 'protectingGroups')}
                ariaControls={`info-protecting-groups-${index}`}
              />
            </div>
            <div
              className={`additional-info-details info-protecting-groups rx-accordion
                          ${isTableVisible.protectingGroups ? '' : 'u-els-display-none'}`}
              id={`info-protecting-groups-${index}`}>
              <ReactionProtectingGroups detail={detail} />
            </div>
          </>
        )}

        {/* Information on Metabolization */}
        {isMetabolizationGroupsVisible && (
          <>
            <div className="additional-info-header">
              <DetailsViewManagerComponent
                title="Information on Metabolization"
                // eslint-disable-next-line react/jsx-no-bind
                setVisibility={this.setVisibility?.bind?.(this, 'metabolizationGroups')}
                ariaControls={`info-metabolization-${index}`}
              />
            </div>
            {isTableVisible.metabolizationGroups && (
              <div
                className="additional-info-details info-metabolization rx-accordion"
                id={`info-metabolization-${index}`}
                ref={this.reactionMetabolizationGroupsContainerRef}>
                <ReactionMetabolizationGroups
                  detail={detail}
                  uniqueId={`info-metabolization-${index}`}
                  containerRef={this.reactionMetabolizationGroupsContainerRef}
                />
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

ReactionAdditionalInfoComponent.propTypes = {
  detail: PropTypes.object.isRequired,
  databaseId: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  reactionId: PropTypes.string,
};
